import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "utils/apiService";
import PageHeader from "components/layout/PageHeader";

const NUMBER_FIELDS = [
  { key: "supplierMonthly", label: "اشتراك المورد - شهري (ريال)" },
  { key: "supplierYearly", label: "اشتراك المورد - سنوي (ريال)" },
  { key: "contractorMonthly", label: "اشتراك المقاول - شهري (ريال)" },
  { key: "contractorYearly", label: "اشتراك المقاول - سنوي (ريال)" },
  { key: "customerMonthly", label: "اشتراك العميل - شهري (ريال)" },
  { key: "customerYearly", label: "اشتراك العميل - سنوي (ريال)" },
  { key: "perOfferUnlockPrice", label: "سعر فتح عرض واحد (ريال)" },
  { key: "trialDays", label: "مدة التجربة المجانية (يوم)" },
  { key: "freeOffersPerRequest", label: "عدد العروض المجانية لكل طلب" },
];

const SubscriptionPricing = () => {
  const [config, setConfig] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const res = await api.get("/pricingConfig");
      if (cancelled) return;
      if (res.error) toast.error(res.error);
      else if (res.data) setConfig(res.data);
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleSave = async () => {
    setSaving(true);
    const body = {};
    for (const { key } of NUMBER_FIELDS) {
      const v = Number(config[key]);
      if (!Number.isFinite(v) || v < 0) {
        toast.error(`قيمة غير صحيحة في "${key}"`);
        setSaving(false);
        return;
      }
      body[key] = v;
    }
    const res = await api.patch("/pricingConfig", body);
    setSaving(false);
    if (res.error) toast.error(res.error);
    else {
      toast.success("تم حفظ الأسعار بنجاح");
      if (res.data) setConfig(res.data);
    }
  };

  return (
    <div className="mt-6">
      <PageHeader
        title="إدارة أسعار الاشتراكات"
        subtitle="جميع الأسعار بالريال السعودي. يتم تطبيق التغييرات فور الحفظ."
      />
      <div className="grid gap-4 rounded-2xl border border-border-muted bg-white p-5 shadow-card dark:border-navy-700 dark:bg-navy-800 md:grid-cols-2">
        {NUMBER_FIELDS.map(({ key, label }) => (
          <label key={key} className="flex flex-col gap-1">
            <span className="text-sm font-medium text-gray-700 dark:text-gray-200">
              {label}
            </span>
            <input
              type="number"
              step="0.01"
              min={0}
              value={config[key] ?? ""}
              onChange={(e) =>
                setConfig((prev) => ({ ...prev, [key]: e.target.value }))
              }
              disabled={loading}
              className="rounded-lg border border-border bg-surface-muted px-3 py-2 text-sm text-navy-700 outline-none transition focus:border-info-500 focus:bg-white dark:border-navy-600 dark:bg-navy-900 dark:text-white"
            />
          </label>
        ))}
      </div>
      <div className="mt-4 flex justify-end">
        <button
          type="button"
          onClick={handleSave}
          disabled={loading || saving}
          className="rounded-lg bg-info-600 px-6 py-2 text-sm font-semibold text-white shadow-card transition hover:bg-info-700 disabled:opacity-60"
        >
          {saving ? "جاري الحفظ" : "حفظ"}
        </button>
      </div>
    </div>
  );
};

export default SubscriptionPricing;
